import {
    ADDED_TO_BASKET_MODAL_ID,
    Position,
    PRODUCT_NOTIFY_ME,
    PRODUCT_STORE_MENU_ID,
} from '@headless-workspace/config';
import { SideMenuModal } from '@headless-workspace/core-ui';
import { PropsWithLocale } from '@headless-workspace/glow-ds';
import {
    ActionStatus,
    NotifyMeModal,
    ProductDetailInfoModal,
    ProductDetailInfoModalContext,
    StoresDeliveryContainer,
} from '../../../../../client';
import { BasketProductValue, VipBrandsValue } from '../../../../../server';
import { ProductAddToBasketModal } from '../../../modals';

export type OpenModalParams = PropsWithLocale &
    (
        | {
              actionStatus: ActionStatus.AddToBasketCondition;
              productAddedToBasket: BasketProductValue;
              vipBrands: VipBrandsValue;
          }
        | {
              actionStatus: ActionStatus.NotifyMeCondition;
              productIds: string[];
          }
        | {
              actionStatus: ActionStatus.ChooseStoreCondition | ActionStatus.ChangeStoreCondition;
              storeModalInfo: {
                  title: string;
                  closeButtonLabel: string;
              };
              hasBackCta: boolean;
          }
    );

type CreateModalOptionsReturnType = { modalId: string; modal: SideMenuModal };

const createModalOptions = (params: OpenModalParams): CreateModalOptionsReturnType | undefined => {
    const basketModalClasses =
        'w-modalAddToCartMobile tablet:w-modalAddToCartTablet m-auto my-1.25 tablet:my-1 minHeightDesktop:my-0';

    switch (params.actionStatus) {
        case ActionStatus.AddToBasketCondition:
            return {
                modalId: ADDED_TO_BASKET_MODAL_ID,
                modal: SideMenuModal({
                    side: Position.None,
                    map: {
                        default: (
                            <ProductAddToBasketModal
                                locale={params.locale}
                                product={params.productAddedToBasket}
                                vipBrands={params.vipBrands}
                            />
                        ),
                    },
                    className: basketModalClasses,
                    isOpen: false,
                    removeOnClose: true,
                }),
            };

        case ActionStatus.NotifyMeCondition:
            return {
                modalId: PRODUCT_NOTIFY_ME,
                modal: SideMenuModal({
                    side: Position.Right,
                    map: {
                        default: <NotifyMeModal locale={params.locale} productIds={params.productIds} />,
                    },
                    isOpen: false,
                    removeOnClose: true,
                }),
            };

        case ActionStatus.ChooseStoreCondition:
        case ActionStatus.ChangeStoreCondition:
            return {
                modalId: PRODUCT_STORE_MENU_ID,
                modal: SideMenuModal({
                    side: Position.Right,
                    map: {
                        default: (
                            <ProductDetailInfoModal
                                title={params.storeModalInfo.title}
                                removeModalOnClose
                                hasBackCta={params.hasBackCta}
                                renderInformation={
                                    <StoresDeliveryContainer
                                        locale={params.locale}
                                        ctaLabel={params.storeModalInfo.closeButtonLabel}
                                    />
                                }
                                context={ProductDetailInfoModalContext.storeSelection}
                                isSidePanelDeliveryZone={true}
                                productModalId={PRODUCT_STORE_MENU_ID}
                            />
                        ),
                    },
                    isOpen: false,
                    removeOnClose: true,
                }),
            };
        default:
            return undefined;
    }
};

export const ProductModalHelpers = {
    createModalOptions,
};
